module.exports = __webpack_public_path__ + "images/footer-logo.856d746.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/image/footer-logo.png
// module id = 636
// module chunks = 0